import { createFileRoute } from '@tanstack/react-router'
import { requireTrainer } from '@/lib/auth-guards'
import { TrainerAttentionPage } from '@/features/trainer-attention/trainer-attention-page'

export const Route = createFileRoute('/_authenticated/trainer/attention')({
  beforeLoad: async () => {
    await requireTrainer()
  },
  component: TrainerAttentionPage,
})
